export const RANDOM_CODE_LENGTH = 4;
// Matching available letters in headset
export const RANDOM_CODE_CHARS = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  "A",
  "Z",
  "E",
  "R",
  "T",
  "Y",
  "U",
  "Q",
  "S",
  "D",
  "F",
  "G",
  "H",
  "J",
  "W",
  "X",
  "C",
  "V",
  "B",
  "N",
  "I",
];

// export const RANDOM_CODE_CHARS = [
//   1,
//   2,
//   3,
//   4,
//   5,
//   6,
//   7,
//   8,
//   9,
//   "A",
//   "B",
//   "C",
//   "D",
//   "E",
//   "F",
//   "G",
//   "H",
//   "I",
//   "J",
//   "K",
//   "L",
//   "M",
//   "N",
//   "O",
//   "P",
//   "Q",
//   "R",
//   "S",
//   "T",
//   "U",
//   "V",
//   "W",
//   "X",
//   "Y",
//   "Z",
// ];
